import { render } from "./fund.vue?vue&type=template&id=3a3c2ec6&scoped=true"
import script from "./fund.vue?vue&type=script&lang=js"
export * from "./fund.vue?vue&type=script&lang=js"

import "./fund.vue?vue&type=style&index=0&id=3a3c2ec6&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3c2ec6"]])

export default __exports__